import { API_ENPOINTS } from '../../constants/api';
import { get } from '../../utils/requests';


export const fetchTimeZones = () => {
  const endpoint = API_ENPOINTS.timeZones;
  return get(endpoint);
};


// WEBPACK FOOTER //
// src/actions/catalogs/apiRequests.js